import { render, staticRenderFns } from "./BussOnline.vue?vue&type=template&id=65dba01c&scoped=true&"
import script from "./BussOnline.vue?vue&type=script&lang=js&"
export * from "./BussOnline.vue?vue&type=script&lang=js&"
import style0 from "./BussOnline.vue?vue&type=style&index=0&id=65dba01c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dba01c",
  null
  
)

export default component.exports